export const CHANGE_BASICINFO = 'CHANGE_BASICINFO'; // 修改基本信息内容
export const CHANGE_OPTION = 'CHANGE_OPTION'; // 修改state字段值
export const CHECK_BASICINFO = 'CHECK_BASICINFO'; // 改变基本信息填写状态
export const CHECK_EXPECTIONINFO = 'CHECK_EXPECTIONINFO'; // 改变求职期望信息状态
export const SET_PRIVACY = 'SET_PRIVACY'; // 隐私设置信息设置
export const SET_BASICINFO = 'SET_BASICINFO'; // 上一份简历信息初始化

export const GET_CHECKCODE = 'GET_CHECKCODE'; // 获取验证码
export const VARIFY_CHECKCODE = 'VARIFY_CHECKCODE'; // 校验验证码
export const CHANGE_HASAUTHED = 'CHANGE_HASAUTHED'; // 改变认证状态
export const CHANGE_BASICITEMS = 'CHANGE_BASICITEMS'; // 改版认证状态

export const CHANGE_UPLOAD_STATE = 'CHANGE_UPLOAD_STATE'; // 图片上传状态
export const CHANGE_SUBMITSTATE = 'CHANGE_SUBMITSTATE'; // 简历发布状态
export const CHANGE_LOGINSTATE = 'CHANGE_LOGINSTATE'; // 更改登录状态
export const SET_RESUME_COUNT = 'SET_RESUME_COUNT'; // 简历份数
export const SET_AREA_DATA = 'SET_AREA_DATA'; // 区域数据

export const SET_BLOCK_INDUSTRY = 'SET_BLOCK_INDUSTRY'; // 屏蔽行业框展示状态
export const SET_HASAUTHEDMOBILE = 'SET_HASAUTHEDMOBILE'; // 设置后置登录使用的手机号或者已认证的手机号

export const CHANGE_EDUTION = 'CHANGE_EDUTION'; // 设置教育经历状态
export const CHECK_EDUINFO = 'CHECK_EDUINFO'; // 校验教育经历

export const SET_ALLCONFIGOTHERDATA = 'SET_ALLCONFIGOTHERDATA'; //静态数据



// WEBPACK FOOTER //
// ./src/module/basic/store/mutation-types.js